import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import Text from '@/components/Text';

const Confirmation = () => {
  const { t: h } = useTranslation('page-auth');
  const confirmation = h('confirmation', {}, { returnObjects: true });
  const { query } = useRouter();
  return (
    <>
      <Text mb={['2.5rem', '2.5rem', '2.5rem']} variant="headlineGrey">
        {confirmation.headline}
      </Text>
      {/* <Text variant="capsTitle">{confirmation.step}</Text> */}
      <Text variant="subtitlePrimary">{confirmation.subheadline}</Text>
      <Text mb={['3.125rem', '3.125rem', '3.125rem']} variant="bodyLightSmallNativ">
        Wir haben Ihnen eine E-Mail an die Adresse
        <b>{` ${query.email} `}</b> gesendet.
        <br />
        <br />
        Bitte bestätigen Sie Ihre Registrierung über den Button in der E-Mail.
      </Text>
    </>
  );
};

export default Confirmation;
